<template>
  <div>
    <div class="content-outer">
      <b-container>
        <b-row>
          <b-col cols="12">
            <div class="def-function-outer content-left">
              <div class="def-func-form">
                <div class="def-func-input-form-group">
                  <div class="clearfix"></div>
                  <div class="def-func-input-group briefing-list-filter">
                    <div class="def-func-input-group-col btn-search">
                      <b-input-group>
                        <b-form-input
                          placeholder="Search"
                          v-model="paginate_params.filter"
                        ></b-form-input>
                        <b-input-group-append is-text>
                          <font-awesome-icon :icon="['fas', 'search']" />
                        </b-input-group-append>
                      </b-input-group>
                    </div>
                  </div>
                </div>
                <b-row>
                  <b-col>
                    <button
                      v-b-modal.modal-edit-user
                      @click="modalClicked()"
                      class="btn btn-width-170"
                      variant="light"
                    >
                      Add New User
                    </button>
                  </b-col>
                  <b-col>
                    <b-form-group v-slot="{ ariaDescribedby }">
                      <b-form-radio-group
                        id="radio-group-2"
                        :aria-describedby="ariaDescribedby"
                        name="radio-sub-component"
                        class="justify-content-space-between"
                        v-model="paginate_params.status"
                        :options="filterOptions"
                      ></b-form-radio-group>
                    </b-form-group>
                  </b-col>
                  <b-col class="text-right">
                    <button
                      :disabled="userResult.length == 0 || !reminderFlag"
                      @click.prevent="sendRemindersCheck()"
                      class="btn btn-width-170"
                      variant="light"
                    >
                      Send Pending Activation Reminders
                    </button>
                  </b-col>
                </b-row>
                <div class="def-func-table manage-users-table">
                  <table>
                    <thead>
                      <tr>
                        <th class="text-left">
                          <span>Users</span>
                        </th>
                        <th class="text-left">
                          <span>Login (Username/Email)</span>
                        </th>
                        <th class="text-left">
                          <span>Employee Group</span>
                        </th>
                        <th class="text-left">
                          <span>Station</span>
                        </th>
                        <th class="text-left">
                          <span>Org Code</span>
                        </th>
                        <th class="text-left">
                          <span>Contract</span>
                        </th>
                        <th class="text-center width-150">
                          <span>Actions</span>
                        </th>
                        <th class="text-center downloadXLSOuter">
                          <div class="downloadXLS">
                            <img
                              v-if="userResult.length > 0"
                              @click.prevent="manageUserList(true)"
                              title="Download users list"
                              src="@/assets/images/downloadXLS.svg"
                            />
                            <img
                              v-else
                              style="cursor: not-allowed"
                              title="Download users list"
                              src="@/assets/images/downloadXLS.svg"
                            />
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        :class="
                          result.status == 'inactive' ||
                          result.status == 'deactive'
                            ? 'inactive'
                            : ''
                        "
                        v-for="(result, index) in userResult"
                        :key="index"
                      >
                        <td
                          class="text-left"
                          style="text-transform: capitalize"
                        >
                          {{ result.name }}
                        </td>
                        <td class="text-left">{{ result.username }}</td>
                        <td class="text-left">{{ result.group_name }}</td>
                        <td class="text-left">
                          {{ result.primary_station_code }}
                        </td>
                        <td class="text-left">{{ result.orga_code }}</td>
                        <td class="text-left">{{ result.contract }}</td>
                        <td>
                          <div
                            class="manage-user-action justify-content-around manage-user-page"
                          >
                            <button
                              v-if="
                                result.status == 'active' ||
                                result.status == 'reactive' ||
                                (result.status == 'inactive' &&
                                  userRole == 'ROLE_SUPERADMIN')
                              "
                            >
                              <img
                                @click="modalClicked(result)"
                                src="@/assets/images/editUser.png"
                                title="Edit"
                              />
                            </button>
                            <button v-else class="btn-inactive">
                              <img
                                src="@/assets/images/editUser.png"
                                title="Edit"
                              />
                            </button>
                            <button
                              v-if="
                                result.status == 'active' ||
                                result.status == 'reactive'
                              "
                              v-b-modal.modal-deactivate-User
                            >
                              <img
                                @click="deactivateModal(result)"
                                src="@/assets/images/deactivate-user.png"
                                title="Deactivate"
                              />
                            </button>
                            <button v-else-if="result.status == 'deactive'">
                              <img
                                @click="modalClicked(result)"
                                src="@/assets/images/deactivate-user.png"
                                title="Reactivate"
                              />
                            </button>
                            <button v-else class="btn-inactive">
                              <img
                                src="@/assets/images/deactivate-user.png"
                                title="Deactivate"
                              />
                            </button>
                            <button
                              :disabled="result.username_type != false"
                              @click="modalClicked(result, 'password')"
                            >
                              <img
                                src="@/assets/images/key.png"
                                title="Generate Password"
                              />
                            </button>
                            <button
                              :disabled="userRole != 'ROLE_SUPERADMIN'"
                              v-b-modal.confirm-delete
                              @click="modalClicked(result, 'delete')"
                            >
                              <img
                                src="@/assets/images/delete.png"
                                title="Delete"
                              />
                            </button>
                          </div>
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <b-pagination
                  v-model="paginate_params.page"
                  :total-rows="rows"
                  :per-page="paginate_params.limit"
                  first-text="First"
                  prev-text="Prev"
                  next-text="Next"
                  last-text="Last"
                ></b-pagination>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-modal
      hide-footer
      id="modal-edit-user"
      size="lg"
      modal-class="flipModal manage-user-modal"
      :title="titleModel"
      centered
      v-bind:content-class="{ show: modalShow, modalActive: modalActive }"
      @hidden="handleClose"
      ok-only
    >
      <div class="def-func-form">
        <ValidationObserver ref="observer" v-slot="{ passes }">
          <b-form @submit.prevent="passes(userInfo)">
            <div class="def-func-input-form-group mb-0">
              <b-row>
                <b-col>
                  <p class="manage-title">User Info & Reporting Line</p>
                  <div class="def-func-input-group">
                    <b-row>
                      <b-col class="def-func-input-group-col" md="4">
                        <ValidationProvider
                          name="Last Name"
                          rules="required"
                          v-slot="{ valid, errors }"
                        >
                          <div class="required-field">
                            <label>Last Name</label>
                            <b-form-input
                              placeholder="Last Name"
                              :disabled="userStatus == 'deactive'"
                              :state="errors[0] ? false : valid ? true : null"
                              v-model="userData.last_name"
                            />
                            <b-form-invalid-feedback>{{
                              errors[0]
                            }}</b-form-invalid-feedback>
                          </div>
                        </ValidationProvider>
                      </b-col>
                      <b-col class="def-func-input-group-col" md="4">
                        <ValidationProvider
                          name="First Name"
                          rules="required"
                          v-slot="{ valid, errors }"
                        >
                          <div class="required-field">
                            <label>First Name</label>
                            <b-form-input
                              placeholder="First Name"
                              :disabled="userStatus == 'deactive'"
                              :state="errors[0] ? false : valid ? true : null"
                              v-model="userData.first_name"
                            />
                            <b-form-invalid-feedback>{{
                              errors[0]
                            }}</b-form-invalid-feedback>
                          </div>
                        </ValidationProvider>
                      </b-col>
                      <b-col class="def-func-input-group-col" md="4">
                        <label>Middle Initial(s)</label>
                        <b-form-input
                          placeholder="Middle Initial(s)"
                          :disabled="userStatus == 'deactive'"
                          v-model="userData.middle_name"
                        />
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="def-func-input-group">
                    <b-row>
                      <b-col md="7">
                        <b-row>
                          <b-col class="def-func-input-group-col" md="6">
                            <b-form-checkbox
                              v-show="userId == ''"
                              v-model="userData.username_type"
                              class="check-user"
                              name="check-user"
                              switch
                              size="lg"
                            ></b-form-checkbox>
                            <div class="required-field">
                              <label v-if="userData.username_type"
                                >Email Address for login</label
                              >
                              <label v-else>Username for login</label>
                              <div class="clearfix"></div>
                              <ValidationProvider
                                v-if="userData.username_type"
                                name="Email Address"
                                v-slot="{ valid, errors }"
                                :rules="`${
                                  userData.username_type ? 'required|email' : ''
                                }`"
                              >
                                <b-form-input
                                  placeholder="Email Address"
                                  :state="
                                    errors[0] ? false : valid ? true : null
                                  "
                                  :disabled="userId != ''"
                                  v-model="userData.username"
                                />
                                <b-form-invalid-feedback>{{
                                  errors[0]
                                }}</b-form-invalid-feedback>
                              </ValidationProvider>
                              <ValidationProvider
                                v-else
                                name="Username"
                                v-slot="{ valid, errors }"
                                :rules="`${
                                  userData.username_type
                                    ? ''
                                    : 'required|alpha_num'
                                }`"
                              >
                                <b-form-input
                                  placeholder="Username"
                                  :state="
                                    errors[0] ? false : valid ? true : null
                                  "
                                  :disabled="userId != ''"
                                  v-model="userData.username"
                                />
                                <b-form-invalid-feedback>{{
                                  errors[0]
                                }}</b-form-invalid-feedback>
                              </ValidationProvider>
                            </div>
                          </b-col>
                          <b-col class="def-func-input-group-col" md="6">
                            <ValidationProvider
                              name="Proxy e-mail"
                              rules="email"
                              v-slot="{ valid, errors }"
                            >
                              <label>Proxy e-mail for notifications</label>
                              <b-form-input
                                placeholder="Proxy e-mail"
                                :state="
                                  errors[0]
                                    ? false
                                    : valid &&
                                      !userData.username_type &&
                                      userData.proxy_email != '' &&
                                      userData.proxy_email != null
                                    ? true
                                    : null
                                "
                                :disabled="userData.username_type"
                                v-model="userData.proxy_email"
                              />
                              <b-form-invalid-feedback>{{
                                errors[0]
                              }}</b-form-invalid-feedback>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col class="def-func-input-group-col" md="5">
                        <label>Cell Phone (Optional)</label>
                        <div class="cell-phone-outer dc-sm-country-code">
                          <VuePhoneNumberInput
                            v-model="phoneVal"
                            class="country-code"
                            :clearable="true"
                            :show-code-on-list="true"
                            :error="
                              isValid == false && cellPhone != '' ? true : false
                            "
                            :valid-color="'#28a745'"
                            :error-color="'#dc3545'"
                            :default-country-code="userData.country_code"
                            @update="phoneData($event)"
                          />
                        </div>
                        <ValidationProvider
                          name="Cell Phone"
                          :rules="`${cellPhone != '' ? 'required' : ''}`"
                          v-slot="{ valid, errors }"
                        >
                          <b-form-input
                            v-show="false"
                            :state="errors[0] ? false : valid ? true : null"
                            v-model="userData.phone_no"
                          />
                          <b-form-invalid-feedback>{{
                            errors[0] | custom_message
                          }}</b-form-invalid-feedback>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="def-func-input-group">
                    <b-row>
                      <b-col class="def-func-input-group-col" md="7">
                        <ValidationProvider
                          name="Employee Group"
                          rules="required"
                          v-slot="{ valid, errors }"
                        >
                          <div class="required-field">
                            <label>Employee Group</label>
                            <b-form-select
                              :state="errors[0] ? false : valid ? true : null"
                              v-model="userData.group"
                              :options="grpResult"
                              @change="reportsToChange"
                            ></b-form-select>
                            <b-form-invalid-feedback>{{
                              errors[0]
                            }}</b-form-invalid-feedback>
                          </div>
                        </ValidationProvider>
                      </b-col>
                      <b-col class="def-func-input-group-col" md="5">
                        <!-- <ValidationProvider v-if="userRole == 'ROLE_SUPERADMIN'"
                          name="Based at Station"
                          rules="required"
                          v-slot="{ valid, errors }"
                        >
                          <div class="required-field">
                            <label>Based at Station</label>
                            <vue-bootstrap-typeahead
                              :data="stationCode"
                              ref="typeahead"
                              v-model="userData.primary_station"
                              :serializer="item => item.code"
                              placeholder="Station Code"
                              :minMatchingChars="1"
                              v-bind:class="{ isInvalid : errors[0], isValid : valid, } "
                              @hit="selectedUser = $event"
                            ></vue-bootstrap-typeahead>
                            <b-form-invalid-feedback style="display:block">{{ errors[0] }}</b-form-invalid-feedback>
                          </div>
                        </ValidationProvider> -->
                        <!-- <span v-else> -->
                        <div class="required-field">
                          <label>Based at Station</label>
                          <typeahead
                            v-if="userData.group != null && !disableStation"
                            refer="typeaheadBasedStation"
                            page="manage_users"
                            :apiFunction="
                              'groups/get_reports_to/' + userData.group
                            "
                            location="based"
                          ></typeahead>
                          <ValidationProvider
                            name="Based at Station"
                            rules="required"
                            v-slot="{ valid, errors }"
                          >
                            <!-- :disabled="userData.group == null" -->
                            <b-form-input
                              v-show="
                                (userData.group == null && disableStation) ||
                                (userData.group != null && disableStation)
                                  ? true
                                  : false
                              "
                              disabled
                              :state="errors[0] ? false : valid ? true : null"
                              v-model="userData.primary_station"
                              placeholder="Station Code"
                            ></b-form-input>
                            <b-form-invalid-feedback>{{
                              errors[0]
                            }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                        <!-- </span> -->
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="def-func-input-group">
                    <b-row>
                      <b-col class="def-func-input-group-col" md="6" sm="12">
                        <ValidationProvider
                          name="Org Code"
                          rules="required"
                          v-slot="{ valid, errors }"
                        >
                          <div class="required-field">
                            <label>Org Code</label>
                            <!-- <b-form-select :disabled="userData.group == null"
                              :state="errors[0] ? false : ( valid ? true : null )"
                              v-model="userData.orga_code"
                              :options="orgResult"
                            ></b-form-select> -->
                            <b-form-input
                              disabled
                              :state="errors[0] ? false : valid ? true : null"
                              v-model="userData.orga_code"
                              placeholder="Org Code"
                            ></b-form-input>
                            <b-form-invalid-feedback>{{
                              errors[0]
                            }}</b-form-invalid-feedback>
                          </div>
                        </ValidationProvider>
                      </b-col>
                      <b-col class="def-func-input-group-col" md="6" sm="12">
                        <ValidationProvider
                          name="Reports To"
                          rules="required"
                          v-slot="{ valid, errors }"
                        >
                          <div class="required-field">
                            <label>Reports To</label>
                            <b-form-select
                              :disabled="userData.group == null"
                              :state="errors[0] ? false : valid ? true : null"
                              v-model="userData.reports_to"
                              :options="reportsToResult"
                            ></b-form-select>
                            <b-form-invalid-feedback>{{
                              errors[0]
                            }}</b-form-invalid-feedback>
                          </div>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>
              <div class="def-func-input-group">
                <b-row>
                  <b-col class="def-func-input-group-col" md="6" sm="12">
                    <ValidationProvider
                      name="Contract"
                      rules="required"
                      v-slot="{ valid, errors }"
                    >
                      <div class="required-field">
                        <label>Contract</label>
                        <b-form-select
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="userData.contract"
                          :options="contractOption"
                        ></b-form-select>
                        <b-form-invalid-feedback>{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </div>
                    </ValidationProvider>
                  </b-col>
                  <b-col class="def-func-input-group-col" md="6" sm="12">
                    <div>
                      <div class="vendor-label-plus required-field">
                        <label>Vendor</label>
                        <b-button
                          :disabled="userData.contract != 'Contracted'"
                          class="add-btn-label"
                          variant="light"
                          v-b-modal.add-vendor
                          >+</b-button
                        >
                      </div>
                      <typeaheadVendor
                        v-if="userData.contract == 'Contracted'"
                        :apiFunction="'vendors/list?filter='"
                      ></typeaheadVendor>
                      <ValidationProvider
                        name="Vendor"
                        :rules="`${
                          userData.contract == 'Contracted' ? 'required' : ''
                        }`"
                        v-slot="{ valid, errors }"
                      >
                        <b-form-input
                          v-show="
                            userData.contract != 'Contracted' ? true : false
                          "
                          :disabled="userData.contract != 'Contracted'"
                          :state="
                            userData.contract != 'Contracted'
                              ? null
                              : errors[0]
                              ? false
                              : valid
                              ? true
                              : null
                          "
                          v-model="userData.vendor"
                          placeholder="Vendor"
                        ></b-form-input>
                        <b-form-invalid-feedback>{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div class="def-func-input-form-group">
              <b-row>
                <b-col md="6" v-if="userRole == 'ROLE_SUPERADMIN'">
                  <b-row>
                    <b-col>
                      <div class="def-func-input-group manage-table-cols">
                        <div class="def-func-input-group-col width-8">
                          <label>Add Station Authority</label>
                          <typeahead
                            :apiFunction="'stations/get_station_codes'"
                          ></typeahead>
                        </div>
                        <div
                          class="def-func-input-group-col btn-add-outer width-4"
                        >
                          <button
                            class="btn add-btn th-add-btn"
                            variant="light"
                            :disabled="tmpStationCode == ''"
                            @click.prevent="getStationCode"
                          >
                            +
                          </button>
                        </div>
                      </div>
                      <div class="def-func-table manage-users-table">
                        <table
                          v-if="
                            secondary_station && secondary_station.length > 0
                          "
                        >
                          <thead>
                            <tr>
                              <th class="text-left">
                                <span>Additional Station Authority</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(code, index) in secondary_station"
                              :key="'secondaryStation_' + index"
                            >
                              <td class="text-left">
                                {{ code.code }}
                                <div class="manage-table-delete">
                                  <button title="Delete Code">
                                    <img
                                      src="@/assets/images/delete.png"
                                      @click.prevent="deleteCode(index)"
                                    />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="6" v-if="userId">
                  <b-row>
                    <b-col>
                      <p class="manage-title">Delegation</p>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mb-4">
                      <div class="def-func-input-group manage-table-cols mb-4">
                        <div class="def-func-input-group-col">
                          <label>Delegate to</label>
                          <typeaheadDelegate
                            :apidata="{
                              area: 'manage_users',
                              distributeTo: 'all',
                            }"
                            :display="'email'"
                            :userFlag="userFlag"
                          ></typeaheadDelegate>
                        </div>
                      </div>
                      <div
                        class="def-func-input-group manage-table-cols input-padding"
                      >
                        <div
                          class="def-func-input-group-col deligation-date-left"
                        >
                          <div
                            :class="{
                              'required-field': delegateData.delegate_to
                                ? true
                                : false,
                            }"
                          >
                            <b-form-group
                              id="from-Date"
                              label="From Date"
                              label-for="From_Date"
                            >
                              <ValidationProvider
                                name="From Date"
                                :rules="`${
                                  delegateData.delegate_to ? 'required' : ''
                                }`"
                                v-slot="{ errors }"
                              >
                                <b-input-group class="date-field">
                                  <b-input-group-append is-text>
                                    <font-awesome-icon
                                      :icon="['far', 'calendar-alt']"
                                    />
                                  </b-input-group-append>
                                  <Datepicker
                                    :disabled="delegateData.delegate_to == ''"
                                    v-model="delegateData.from_date"
                                    :disabled-dates="stateFrom.disabledDates"
                                  ></Datepicker>
                                </b-input-group>
                                <input
                                  v-show="false"
                                  id="From_Date"
                                  name="From_Date"
                                  v-model="delegateData.from_date"
                                  aria-describedby="from_Date_error"
                                />
                                <b-form-invalid-feedback
                                  style="display: block"
                                  >{{ errors[0] }}</b-form-invalid-feedback
                                >
                              </ValidationProvider>
                            </b-form-group>
                          </div>
                        </div>
                        <div
                          class="def-func-input-group-col deligation-date-right"
                        >
                          <div
                            :class="{
                              'required-field': delegateData.delegate_to
                                ? true
                                : false,
                            }"
                          >
                            <b-form-group
                              id="to-Date"
                              label="To Date"
                              label-for="To_Date"
                            >
                              <ValidationProvider
                                name="To Date"
                                :rules="`${
                                  delegateData.delegate_to ? 'required' : ''
                                }`"
                                v-slot="{ errors }"
                              >
                                <b-input-group class="date-field">
                                  <b-input-group-append is-text>
                                    <font-awesome-icon
                                      :icon="['far', 'calendar-alt']"
                                    />
                                  </b-input-group-append>
                                  <Datepicker
                                    :disabled="delegateData.delegate_to == ''"
                                    v-model="delegateData.to_date"
                                    :disabled-dates="stateTo.disabledDates"
                                  ></Datepicker>
                                </b-input-group>
                                <input
                                  v-show="false"
                                  id="To_Date"
                                  name="To_Date"
                                  v-model="delegateData.to_date"
                                  aria-describedby="to_Date_error"
                                />
                                <b-form-invalid-feedback
                                  style="display: block"
                                  >{{ errors[0] }}</b-form-invalid-feedback
                                >
                              </ValidationProvider>
                            </b-form-group>
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <div class="clearfix"></div>
              <div class="w-100">
                <b-button
                  type="submit"
                  variant="light"
                  class="float-right btn-rename-delete"
                  >{{ buttonText }}</b-button
                >
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </div>

      <template v-slot:modal-footer></template>
    </b-modal>
    <b-modal
      hide-footer
      id="modal-check-user"
      size="lg"
      modal-class="flipModal manage-user-modal"
      title="Generate Password"
      @hidden="handleClose"
      centered
      ok-only
    >
      <div class="checkUser-printPreview" ref="content">
        <div class="row">
          <div class="col">
            <label class="mb-4"
              ><b class="font-16"
                >Please find your user details below.</b
              ></label
            >
          </div>
        </div>
        <div class="row label-row">
          <div class="col">
            <label
              >Name:
              <span
                >{{ userData.first_name | prependSpace
                }}{{ userData.middle_name | prependSpace
                }}{{ userData.last_name }}</span
              ></label
            >
          </div>
          <div class="col">
            <label
              >Cell Phone:
              <span>{{ userData.contact_num | checkEmpty }}</span></label
            >
          </div>
        </div>
        <div class="row label-row">
          <div class="col">
            <label
              >Employee Group: <span>{{ userDetails.group_name }}</span></label
            >
          </div>
          <div class="col">
            <label
              >Reports To: <span>{{ userDetails.reports_to }}</span></label
            >
          </div>
        </div>
        <div class="row label-row">
          <div class="col">
            <label
              >Based at Station:
              <span>{{ userData.primary_station }}</span></label
            >
          </div>
          <div class="col">
            <label
              >Org Code: <span>{{ userData.orga_code }}</span></label
            >
          </div>
        </div>
        <div class="row label-row">
          <div class="col">
            <label
              >Username: <span>{{ userData.username }}</span></label
            >
          </div>
          <div class="col">
            <label class="generate-password">
              <div class="required-field">
                <label>Password:</label>
              </div>
              <span>{{ password }}</span></label
            >
            <font-awesome-icon
              :icon="['fas', 'undo-alt']"
              @click.prevent="onClickGenrate"
            />
          </div>
        </div>
        <div class="row label-row">
          <div class="col">
            <label class="checkUser-station-authority"
              >Station Authority:
              <span v-if="secondary_station.length > 0">
                <span
                  v-for="(code, ssindex) in secondary_station"
                  :key="ssindex"
                >
                  {{ code.code
                  }}<span v-if="secondary_station.length != ssindex + 1"
                    >,</span
                  ></span
                >
              </span>
              <span v-else>-</span>
            </label>
          </div>
        </div>
      </div>
      <b-row>
        <b-col class="text-center mt-3">
          <b-button
            class="ml-3 width-3"
            variant="light"
            @click.prevent="updatePassword"
            :disabled="password == ''"
            >Update</b-button
          >
          <b-button
            class="ml-3 width-3"
            variant="light"
            @click="downloadPDF()"
            :disabled="enablePrint == false"
            >Print</b-button
          >
          <b-button
            class="ml-3 width-3"
            variant="light"
            @click="$bvModal.hide('modal-check-user')"
            >Cancel</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      hide-footer
      id="modal-deactivate-User"
      size="md"
      modal-class="flipModal manage-user-modal"
      title="Deactivate User"
      centered
      @hidden="resetModal"
    >
      <div class="def-func-input-form-group">
        <ValidationObserver ref="observerDeactivate" v-slot="{ passes }">
          <b-form @submit.prevent="passes(userDeactivate)">
            <b-row>
              <b-col>
                <div class="def-func-input-group">
                  <ValidationProvider
                    name="Reason For Deactivation"
                    rules="required"
                    v-slot="{ valid, errors }"
                  >
                    <div class="required-field">
                      <label>Reason For Deactivation</label>
                      <b-form-textarea
                        :state="errors[0] ? false : valid ? true : null"
                        v-model="deactivateReason"
                        id="textarea"
                        rows="6"
                        max-rows="6"
                        placeholder="Reason For Deactivation"
                      ></b-form-textarea>
                      <b-form-invalid-feedback>{{
                        errors[0]
                      }}</b-form-invalid-feedback>
                    </div>
                  </ValidationProvider>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-button
                  @click="$bvModal.hide('modal-deactivate-User')"
                  class="btn-rename-delete"
                  variant="light"
                  >Cancel</b-button
                >
              </b-col>
              <b-col>
                <b-button
                  type="submit"
                  class="btn-rename-delete float-right"
                  variant="light"
                  >Deactivate</b-button
                >
              </b-col>
            </b-row>
          </b-form>
        </ValidationObserver>
      </div>
      <template v-slot:modal-footer></template>
    </b-modal>
    <b-modal
      @show="showVendorPopUp"
      id="add-vendor"
      title="Vendor"
      hide-footer
      size="lg"
      modal-class="flipModal manage-user-modal"
    >
      <div class="def-func-table manage-users-table vendor-modal-content">
        <ValidationObserver ref="observerDeactivate" v-slot="{ passes }">
          <b-form @submit.prevent="passes(addVendor)">
            <b-row>
              <b-col class="def-func-input-group-col" md="6" sm="12">
                <ValidationProvider
                  name="Vendor name"
                  rules="required"
                  v-slot="{ valid, errors }"
                >
                  <div class="required-field">
                    <label>Vendor Name</label>
                    <b-form-input
                      :state="errors[0] ? false : valid ? true : null"
                      v-model="vendorName"
                      placeholder="Vendor Name"
                    ></b-form-input>
                    <b-form-invalid-feedback>{{
                      errors[0]
                    }}</b-form-invalid-feedback>
                  </div>
                </ValidationProvider>
              </b-col>
              <b-col md="6" sm="12" class="add-vendor-btn">
                <b-button variant="link" class="btn add-btn" type="submit"
                  >+</b-button
                >
              </b-col>
            </b-row>
          </b-form>
        </ValidationObserver>
        <table>
          <thead>
            <tr>
              <th class="text-left"><span>Vendor Name</span></th>
              <th class="text-center"><span>Actions</span></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, indexVendor) in vendorData" :key="indexVendor">
              <td class="text-left" style="text-transform: capitalize">
                {{ data.name }}
              </td>
              <td class="text-center">
                <div
                  class="manage-user-action justify-content-around manage-user-page"
                >
                  <button
                    v-b-modal.confirm-delete
                    @click.prevent="confirm_popup(data)"
                  >
                    <img src="@/assets/images/delete.png" title="Delete" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-pagination
        v-model="vendorPaginate.page"
        :total-rows="vendorPaginate.rows"
        :per-page="vendorPaginate.limit"
        first-text="First"
        prev-text="Prev"
        next-text="Next"
        last-text="Last"
      ></b-pagination>
    </b-modal>
    <div class="text-center spinner-div overlay" v-show="messsage_loader">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
    <confirmModal></confirmModal>
    <div
      class="text-center spinner-div overlay load-outer"
      v-show="reminder_loader"
    >
      <label class="wait-text">Please wait...</label>
      <br />
      <b-spinner variant="primary" label="Spinning"></b-spinner>
      <br />
      <label v-show="count_loader" class="loading-text"
        >Completed {{ completedCount }}/{{ totalCount }}</label
      >
    </div>
    <detailResp></detailResp>
    <noInternetModal />
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { HTTP_formdata, HTTP } from "../../constants/http-common";
import typeahead from "../../components/admin_layouts/dashboard_layouts/typeahead_search_stationcode";
import typeaheadVendor from "../../components/admin_layouts/dashboard_layouts/typeahead_vendor";
import typeaheadDelegate from "../../components/admin_layouts/dashboard_layouts/typeahead_search_users";
import { EventBus } from "../../main";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import axios from "axios";
import { BASE_URL_VER } from "../../constants/app-constants";
import { isloggedin } from "../../constants/app-constants";
import confirmModal from "../../components/admin_layouts/dashboard_layouts/status_message/confirm_resp";
import detailResp from "../../components/admin_layouts/dashboard_layouts/status_message/distribution_failed";
import noInternetModal from "../../components/admin_layouts/dashboard_layouts/status_message/no-internet";
export default {
  data() {
    return {
      modalShow: false,
      modalActive: false,
      userResult: [],
      rows: 10,
      paginate_params: {
        filter: "",
        status: "all",
        excel: 0,
        page: 1,
        limit: "10",
      },
      grpResult: [
        {
          value: null,
          text: "Select",
          disabled: true,
        },
      ],
      reportsToResult: [
        {
          value: null,
          text: "Select",
          disabled: true,
        },
      ],
      titleModel: "",
      cellPhone: "",
      userData: {
        first_name: "",
        middle_name: null,
        last_name: "",
        username: "",
        phone_no: "",
        country_calling_code: "",
        country_code: "",
        group: null,
        primary_station: "",
        orga_code: null,
        reports_to: null,
        secondary_station: [],
        contract: null,
        username_type: true,
        proxy_email: "",
        vendor: "",
      },
      stationCode: [],
      secondary_station: [],
      searchQuery: {
        code: "",
      },
      orgResult: [
        {
          value: null,
          text: "Select",
          disabled: true,
        },
      ],
      userId: "",
      buttonText: "+",
      tmpStationCode: "",
      userPrimary_station: "",
      userRole: "",
      userStatus: "",
      deactivateReason: "",
      delegateData: {
        delegate_by: "",
        delegate_to: "",
        from_date: "",
        to_date: "",
      },
      stateTo: {
        disabledDates: {
          to: new Date(),
          from: "",
        },
      },
      stateFrom: {
        disabledDates: {
          to: new Date(),
          from: "",
        },
      },
      userFlag: "",
      response: {
        msg: "",
        popup: false,
      },
      contractOption: [
        { value: null, text: "Select", disabled: true },
        {
          value: "Own Employee",
          text: "Own Employee",
          disabled: isloggedin.contract == "Contracted" ? true : false,
        },
        { value: "Contracted", text: "Contracted" },
      ],
      primanyStationId: "",
      selectedUser: "",
      userDetails: {
        group_name: "",
        reports_to: "",
      },
      password: "",
      enablePrint: false,
      phoneVal: "",
      isValid: false,
      messsage_loader: false,
      reminder_loader: false,
      count_loader: false,
      filterOptions: [
        { value: "all", text: "All" },
        { value: "active", text: "Active" },
        { value: "inactive", text: "Inactive" },
      ],
      reminderFlag: true,
      totalCount: 0,
      completedCount: 0,
      proxyEmailCount: {
        success: 0,
        fail: 0,
      },
      emailCount: {
        success: 0,
        fail: 0,
      },
      nonEmailCount: 0,
      inactiveUserList: [],
      timer: false,
      hundredCounter: 0,
      axiosSource: "",
      request: null,
      reminderCheck: false,
      timerCheck: false,
      counterAPICheck: false,
      counterCheck: false,
      vendorName: "",
      vendorPaginate: {
        page: 1,
        limit: 10,
        rows: 10,
      },
      vendorData: [],
      vendorDetail: {
        flag: false,
        data: "",
      },
      disableStation: true,
    };
  },
  components: {
    typeahead,
    Datepicker,
    typeaheadDelegate,
    confirmModal,
    detailResp,
    noInternetModal,
    typeaheadVendor,
  },
  beforeMount() {
    this.manageUserList();
    this.getGrpList();
    // this.getOrgList();
    this.userRole = this.$cookies.get("user").data.roles[0];
    this.networkConnect();
  },
  watch: {
    // "userData.primary_station"(newQuery) {
    //   if (newQuery && this.userRole == 'ROLE_SUPERADMIN') {
    //     this.searchQuery.code = newQuery;
    //     HTTP_formdata.post("stations/get_station_codes", this.searchQuery)
    //       .then(response => {
    //         this.stationCode = response.data;
    //       })
    //       .catch(err => {});
    //   }
    //   deep: true;
    // },
    "paginate_params.page": {
      handler() {
        this.userResult = [];
        this.manageUserList();
        deep: true;
      },
    },
    "paginate_params.filter": {
      handler() {
        this.userResult = [];
        this.manageUserList();
        deep: true;
      },
    },
    "paginate_params.status": {
      handler() {
        this.userResult = [];
        this.manageUserList();
        deep: true;
      },
    },
    "delegateData.from_date": {
      handler(val) {
        if (this.delegateData.from_date) {
          this.stateTo.disabledDates.to = this.delegateData.from_date;
        }
        deep: true;
      },
    },
    "delegateData.to_date": {
      handler(val) {
        if (this.delegateData.to_date) {
          this.stateFrom.disabledDates.from = this.delegateData.to_date;
        }
        deep: true;
      },
    },
    selectedUser(val) {
      this.primanyStationId = val.public_id;
      this.userData.primary_station = val.code;
    },
    "userData.username_type": {
      handler(val) {
        if (val) {
          this.userData.proxy_email = "";
        }
        deep: true;
      },
    },
    onLine(val) {
      if (val != null) {
        this.networkConnect(val);
      }
    },
    "vendorPaginate.page": {
      handler() {
        this.vendorData = [];
        this.listVendor();
        deep: true;
      },
    },
    "userData.contract": {
      handler(val) {
        if (val != "Contracted") {
          this.userData.vendor = "";
          EventBus.$emit("clearVendorData");
        }
        deep: true;
      },
    },
  },
  created() {
    EventBus.$on("typeaheadSearchStationcode", (searchStationcode) => {
      if (searchStationcode.location) {
        this.userData.primary_station = searchStationcode.typesearch
          ? searchStationcode.typesearch.code
          : "";
        this.primanyStationId = searchStationcode.typesearch
          ? searchStationcode.typesearch.public_id
          : "";
        this.userData.orga_code = searchStationcode.typesearch
          ? searchStationcode.typesearch.org_code
          : null;
      } else {
        this.tmpStationCode = searchStationcode ? searchStationcode : "";
      }
    });
    EventBus.$on("typeahead_search_users", (users_Code) => {
      this.delegateData.delegate_to = users_Code.public_id;
    });
    EventBus.$on("deleteConfirmation", (response) => {
      if (response == "delete") {
        this.messsage_loader = true;
        if (this.vendorDetail.flag) {
          this.vendorDetail.flag = false;
          this.deleteVendor();
        } else this.deleteUser();
      }
    });
    EventBus.$on("noConnectionOk", (newQuery) => {
      if (newQuery == "Okay") {
        this.networkConnect();
      }
    });
    EventBus.$on("closeConfirmDelete", (newQuery) => {
      this.vendorDetail.flag = false;
    });
    EventBus.$on("typeaheadSearchVendor", (vendorData) => {
      this.userData.vendor = vendorData ? vendorData.public_id : "";
    });
  },
  filters: {
    prependSpace: function (value) {
      return value + " ";
    },
    checkEmpty: function (value) {
      return value ? value : "-";
    },
    custom_message: function (value) {
      if (value == "The Cell Phone field is required") {
        return "The Cell Phone field must have a valid phone number";
      } else {
        return value;
      }
    },
  },
  beforeCreate() {
    EventBus.$off("typeaheadSearchStationcode");
    EventBus.$off("typeahead_search_users");
    EventBus.$off("typeaheadSearchVendor");
  },
  computed: {
    onLine() {
      return this.$store.getters.networkConnection;
    },
  },
  methods: {
    phoneData(event) {
      this.isValid = event.isValid;
      this.cellPhone = event.nationalNumber ? event.nationalNumber : "";
      if (event.isValid == true) {
        this.userData.phone_no = event.nationalNumber
          ? event.nationalNumber
          : "";
        this.userData.country_calling_code = event.countryCallingCode
          ? event.countryCallingCode
          : "";
        this.userData.country_code = event.countryCode ? event.countryCode : "";
      } else {
        this.userData.phone_no = "";
        this.userData.country_calling_code = "";
        this.userData.country_code = "";
      }
    },
    deactivateModal(result) {
      if (result) {
        this.userId = result.public_id;
      }
    },
    resetModal() {
      this.userId = "";
      this.deactivateReason = "";
    },
    userDeactivate() {
      this.messsage_loader = true;
      let deactivate = {
        reason: this.deactivateReason,
        status: "deactive",
      };
      HTTP_formdata.put("users/deactivate_users/" + this.userId, deactivate)
        .then((response) => {
          if (response.status == 200) {
            this.messsage_loader = false;
            this.response.msg = response.data;
            this.response.popup = true;
            EventBus.$emit("success_resp", this.response);
            this.userId = "";
            this.deactivateReason = "";
            this.$nextTick(() => {
              this.$refs.observerDeactivate.reset();
              this.$bvModal.hide("modal-deactivate-User");
            });
            this.manageUserList();
          }
        })
        .catch((err) => {
          this.messsage_loader = false;
        });
    },
    modalClicked(result, type) {
      if (result) {
        this.userStatus = result.status;
        this.userId = result.public_id;
        this.userData.proxy_email = result.proxy_email;
        if (!type) {
          if (this.userStatus == "deactive") {
            this.titleModel = "Reactivate User";
            this.buttonText = "Reactivate";
          } else {
            this.titleModel = "Edit User";
            this.buttonText = "Update";
          }
          HTTP.get("users/get_user_details/" + this.userId)
            .then((resp) => {
              let response = resp.data[0];
              if (resp.status == 200) {
                this.userData.first_name = response.name.first;
                this.userData.middle_name = response.name.middle
                  ? response.name.middle
                  : "";
                this.userData.last_name = response.name.last;
                this.userData.username = response.username;
                this.userData.group = response.group_id;
                this.userData.phone_no =
                  response.contact_num != null && response.contact_num.phone_no
                    ? response.contact_num.phone_no
                    : "";
                this.cellPhone =
                  response.contact_num != null && response.contact_num.phone_no
                    ? response.contact_num.phone_no
                    : "";
                this.phoneVal =
                  response.contact_num != null && response.contact_num.phone_no
                    ? response.contact_num.phone_no
                    : "";
                this.userData.country_calling_code =
                  response.contact_num != null &&
                  response.contact_num.country_calling_code
                    ? response.contact_num.country_calling_code
                    : "";
                this.userData.country_code =
                  response.contact_num != null &&
                  response.contact_num.country_code
                    ? response.contact_num.country_code
                    : "";
                this.isValid =
                  response.contact_num != null && response.contact_num.phone_no
                    ? true
                    : false;
                if (this.userData.group != null) {
                  this.reportsToChange();
                }
                this.userData.primary_station = response.primary_station_code;
                this.primanyStationId = response.station_public_id;
                this.disableStation = response.disable_station;
                this.userData.orga_code = response.orga_code;
                this.userData.reports_to = response.reports_to_id;
                this.userData.contract = response.contract;
                this.userData.username_type =
                  response.username_type == null
                    ? true
                    : response.username_type;
                if (response.delegated_to_id) {
                  this.delegateData.delegate_to = response.delegated_to_id;
                  this.userFlag = response.delegated_to_name;
                  this.delegateData.from_date = new Date(
                    response.from_date.date
                  );
                  this.delegateData.to_date = new Date(response.to_date.date);
                  this.stateFrom.disabledDates.from = this.delegateData.to_date;
                  this.stateTo.disabledDates.to = this.delegateData.from_date;
                } else {
                  this.delegateData.delegate_to = "";
                  this.userFlag = "";
                  this.delegateData.from_date = "";
                  this.delegateData.to_date = "";
                  this.stateFrom.disabledDates.from = "";
                  this.stateTo.disabledDates.to = new Date();
                }
                if (response.secondary_stations) {
                  this.secondary_station = response.secondary_stations;
                } else {
                  this.secondary_station = [];
                }
                this.userData.secondary_station = [];
                setTimeout(() => {
                  // if ( this.userRole == 'ROLE_SUPERADMIN' ) {
                  //   if (this.$refs.typeahead)
                  //     this.$refs.typeahead.inputValue = response.primary_station_code;
                  // } else {
                  EventBus.$emit("stationData", response.primary_station_code);
                  this.disableStation = response.disable_station;
                  this.userData.primary_station = response.primary_station_code;
                  this.primanyStationId = response.station_public_id;
                  if (this.userData.contract == "Contracted") {
                    EventBus.$emit("vendorData", response.vendor_name);
                    this.userData.vendor = response.vendor_public_id;
                  }
                  // }
                }, 1000);
                this.$bvModal.show("modal-edit-user");
              }
            })
            .catch((err) => {});
        } else {
          if (type == "delete") {
            let displayName = result.name + " (" + result.username + ")";
            EventBus.$emit("deleteSelected", displayName);
          } else {
            HTTP.get("users/get_random_password/" + this.userId)
              .then((resp) => {
                if (resp.status == 200) {
                  let response = resp.data[0];
                  this.userData.first_name = response.name.first;
                  this.userData.middle_name = response.name.middle
                    ? response.name.middle
                    : "";
                  this.userData.last_name = response.name.last;
                  this.userData.username = response.username;
                  this.userData.contact_num =
                    response.contact_num != null &&
                    response.contact_num.phone_no
                      ? "+" +
                        response.contact_num.country_calling_code +
                        response.contact_num.phone_no
                      : "";
                  this.userDetails.group_name = response.group_name
                    ? response.group_name
                    : "";
                  this.userDetails.reports_to = response.reports_to
                    ? response.reports_to
                    : "";
                  this.password = response.random_password
                    ? response.random_password
                    : "";
                  this.enablePrint = response.random_password ? true : false;
                  this.userData.primary_station = response.primary_station_code;
                  this.userData.orga_code = response.orga_code;
                  if (response.secondary_stations) {
                    this.secondary_station = response.secondary_stations;
                  } else {
                    this.secondary_station = [];
                  }
                  this.userData.secondary_station = [];
                  this.$bvModal.show("modal-check-user");
                }
              })
              .catch((err) => {});
          }
        }
      } else {
        this.userId = "";
        this.titleModel = "Create User";
        this.buttonText = "Add";
        this.disableStation = true;
      }
    },
    deleteCode(index) {
      this.secondary_station.splice(index, 1);
    },
    handleClose() {
      this.userStatus = "";
      this.userId = "";
      this.userData.first_name = "";
      this.userData.middle_name = null;
      this.userData.last_name = "";
      this.userData.username = "";
      this.userData.proxy_email = "";
      this.cellPhone = "";
      this.phoneVal = "";
      this.userData.phone_no = "";
      this.userData.country_calling_code = "";
      this.userData.country_code = "";
      this.isValid = false;
      this.userData.group = null;
      this.userData.primary_station = "";
      this.primanyStationId = "";
      this.userData.orga_code = null;
      this.userData.reports_to = null;
      this.userData.secondary_station = [];
      this.secondary_station = [];
      this.delegateData.delegate_by = "";
      this.delegateData.delegate_to = "";
      this.userData.contract = null;
      this.userData.username_type = true;
      this.userDetails = {
        group_name: "",
        reports_to: "",
      };
      this.password = "";
      this.userFlag = "";
      this.delegateData.from_date = "";
      this.delegateData.to_date = "";
      this.stateTo.disabledDates.to = new Date();
      this.stateFrom.disabledDates.to = new Date();
      this.stateTo.disabledDates.from = "";
      this.stateFrom.disabledDates.from = "";
      if (this.$refs.typeahead) {
        this.$refs.typeahead.inputValue = "";
      }
      if (this.$refs.typeaheadStation) {
        this.$refs.typeaheadStation.inputValue = "";
      }
      this.$nextTick(() => {
        if (this.$refs.observer) {
          this.$refs.observer.reset();
        }
      });
    },
    manageUserList(excel) {
      this.paginate_params.excel = excel ? 1 : 0;
      // HTTP_formdata.post("users/search_filter", this.paginate_params)
      // let apiHeader = ( excel ) ? axios({ url: BASE_URL_VER + "users/search_filter", method: 'POST', data: this.paginate_params, responseType: 'blob', headers: { Authorization: "Bearer " + isloggedin.token, "Content-Type": "application/json" } }) : HTTP_formdata.post("users/search_filter", this.paginate_params)
      HTTP_formdata.post(
        "users/search_filter",
        this.paginate_params,
        excel ? { responseType: "blob" } : ""
      )
        .then((response) => {
          if (response.status == 200) {
            if (excel) {
              var fileURL = window.URL.createObjectURL(
                new Blob([response.data])
              );
              var fileLink = document.createElement("a");
              fileLink.href = fileURL;
              fileLink.setAttribute("download", "Users.xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();
            } else {
              if (response.data.data != "Search Not Found") {
                this.userResult = response.data.data;
                this.rows = response.data.total_length;
                this.reminderFlag =
                  response.data.inactive_users == 1 ? true : false;
                if (this.userRole == "ROLE_SUPERADMIN") {
                  this.userPrimary_station = "";
                } else {
                  this.userPrimary_station = response.data.primary_station;
                }
              } else {
                this.userResult = [];
                this.rows = 1;
              }
            }
          }
        })
        .catch((error) => {});
    },
    // getGrpList() {
    //   let page = {};
    //   HTTP_formdata.post("groups/display_groups", page)
    //     .then(response => {
    //       for (var i = 0; i < response.data.data.length; i++) {
    //         this.grpResult.push({
    //           value: response.data.data[i].group_public_id,
    //           text: response.data.data[i].group_name
    //         });
    //       } this.grpResult.sort(function(a, b) {
    //         var textA = a.group_name;
    //         var textB = b.group_name;
    //         return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    //       })
    //     }); console.log(this.grpResult, 'grpResult')
    //     .catch(error => {});
    // },
    getGrpList() {
      let page = {};
      HTTP_formdata.post("groups/display_groups", page)
        .then((response) => {
          // Sort the array alphabetically by the group_name property
          this.grpResult = response.data.data
            .sort((a, b) => {
              const nameA = a.group_name.toUpperCase(); // ignore case
              const nameB = b.group_name.toUpperCase(); // ignore case
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0; // names are equal
            })
            .map((group) => ({
              value: group.group_public_id,
              text: group.group_name,
            }));
        })
        .catch((error) => {});
    },
    getOrgList() {
      HTTP.get("organisations/display_organisations")
        .then((response) => {
          for (var i = 0; i < response.data.length; i++) {
            this.orgResult.push({
              value: response.data[i].code,
              text: response.data[i].code,
            });
          }
        })
        .catch((error) => {});
    },
    getStationCode() {
      if (this.tmpStationCode) {
        if (this.secondary_station.length == 0) {
          this.secondary_station.push(this.tmpStationCode);
          this.tmpStationCode = "";
          let clear = "clear";
          EventBus.$emit("clearData", clear);
        } else {
          let stationCheck = false;
          for (let i = 0; i < this.secondary_station.length; i++) {
            if (this.secondary_station[i].code == this.tmpStationCode.code) {
              stationCheck = true;
            }
          }
          if (stationCheck == false) {
            this.secondary_station.push(this.tmpStationCode);
            this.tmpStationCode = "";
            let clear = "clear";
            EventBus.$emit("clearData", clear);
          } else {
            this.tmpStationCode = "";
            let clear = "clear";
            EventBus.$emit("clearData", clear);
          }
        }
      }
    },
    async userInfo() {
      this.messsage_loader = true;
      if (this.userId == "") {
        // Add User
        if (this.secondary_station.length > 0) {
          let secondaryStaion = [];
          for (let i = 0; i < this.secondary_station.length; i++) {
            secondaryStaion.push(this.secondary_station[i].public_id);
          }
          this.userData.secondary_station = secondaryStaion;
        }
        this.userData.primary_station = this.primanyStationId;
        HTTP_formdata.post("users/addUsers", this.userData)
          .then((response) => {
            if (response.status == 200) {
              this.messsage_loader = false;
              this.response.msg = response.data.resposne;
              this.response.popup = true;
              EventBus.$emit("success_resp", this.response);
              if (this.delegateData.delegate_to != "") {
                this.delegateData.delegate_by = response.data.public_id;
                HTTP_formdata.post(
                  "delegation/add_delegation",
                  this.delegateData
                )
                  .then((response) => {
                    this.userStatus = "";
                    this.userId = "";
                    this.userData.first_name = "";
                    this.userData.middle_name = null;
                    this.userData.last_name = "";
                    this.userData.username = "";
                    this.phoneVal = "";
                    this.userData.phone_no = "";
                    this.userData.country_calling_code = "";
                    this.userData.country_code = "";
                    this.isValid = false;
                    this.cellPhone = "";
                    this.userData.group = null;
                    this.userData.primary_station = "";
                    this.primanyStationId = "";
                    this.userData.orga_code = null;
                    this.userData.reports_to = null;
                    this.userData.secondary_station = [];
                    this.secondary_station = [];
                    this.delegateData.delegate_by = "";
                    this.delegateData.delegate_to = "";
                    this.userData.contract = null;
                    this.userData.username_type = true;
                    this.userDetails = {
                      group_name: "",
                      reports_to: "",
                    };
                    this.userFlag = "";
                    this.delegateData.from_date = "";
                    this.delegateData.to_date = "";
                    this.stateTo.disabledDates.to = new Date();
                    this.stateFrom.disabledDates.to = new Date();
                    this.stateTo.disabledDates.from = "";
                    this.stateFrom.disabledDates.from = "";
                    if (this.$refs.typeahead) {
                      this.$refs.typeahead.inputValue = "";
                    }
                    if (this.$refs.typeaheadStation) {
                      this.$refs.typeaheadStation.inputValue = "";
                    }
                    this.$nextTick(() => {
                      this.$refs.observer.reset();
                      this.$bvModal.hide("modal-edit-user");
                    });
                    this.handleClose();
                    this.manageUserList();
                  })
                  .catch((error) => {});
              } else {
                this.userStatus = "";
                this.userId = "";
                this.userData.first_name = "";
                this.userData.middle_name = null;
                this.userData.last_name = "";
                this.userData.username = "";
                this.phoneVal = "";
                this.userData.phone_no = "";
                this.userData.country_calling_code = "";
                this.userData.country_code = "";
                this.isValid = false;
                this.cellPhone = "";
                this.userData.group = null;
                this.userData.primary_station = "";
                this.primanyStationId = "";
                this.userData.orga_code = null;
                this.userData.reports_to = null;
                this.userData.secondary_station = [];
                this.secondary_station = [];
                this.userData.contract = null;
                this.userData.username_type = true;
                this.userDetails = {
                  group_name: "",
                  reports_to: "",
                };
                if (this.$refs.typeahead) {
                  this.$refs.typeahead.inputValue = "";
                }
                if (this.$refs.typeaheadStation) {
                  this.$refs.typeaheadStation.inputValue = "";
                }
                this.$nextTick(() => {
                  this.$refs.observer.reset();
                  this.$bvModal.hide("modal-edit-user");
                });
                this.handleClose();
                this.manageUserList();
              }
            }
          })
          .catch((err) => {
            this.messsage_loader = false;
            if (err.response.status == 400) {
              this.response.msg = err.response.data.response;
              this.response.popup = true;
              EventBus.$emit("error_resp", this.response);
            }
          });
      } else {
        // Edit User
        if (this.secondary_station.length > 0) {
          let myArray = [...new Set(this.secondary_station)];
          this.secondary_station = myArray;
          let secondaryStaion = [];
          for (let i = 0; i < this.secondary_station.length; i++) {
            secondaryStaion.push(this.secondary_station[i].public_id);
          }
          this.userData.secondary_station = secondaryStaion;
        }
        if (this.userStatus == "deactive") {
          let reactive = {
            phone_no: this.userData.phone_no,
            country_calling_code: this.userData.country_calling_code,
            country_code: this.userData.country_code,
            group: this.userData.group,
            primary_station: this.primanyStationId,
            orga_code: this.userData.orga_code,
            reports_to: this.userData.reports_to,
            secondary_station: this.userData.secondary_station,
            contract: this.userData.contract,
            proxy_email: this.userData.proxy_email,
            vendor: this.userData.vendor,
          };
          HTTP_formdata.put("users/reactivate_users/" + this.userId, reactive)
            .then((response) => {
              if (response.status == 200) {
                this.messsage_loader = false;
                // this.response.msg = response.data
                // this.response.popup = true
                // EventBus.$emit("success_resp", this.response);
                if (this.delegateData.delegate_to != "") {
                  this.delegateData.delegate_by = this.userId;
                  HTTP_formdata.post(
                    "delegation/add_delegation",
                    this.delegateData
                  )
                    .then((resp) => {
                      this.response.msg = response.data;
                      this.response.popup = true;
                      EventBus.$emit("success_resp", this.response);
                      this.userStatus = "";
                      this.userId = "";
                      this.userData.first_name = "";
                      this.userData.middle_name = null;
                      this.userData.last_name = "";
                      this.userData.username = "";
                      this.userData.proxy_email = "";
                      this.phoneVal = "";
                      this.userData.phone_no = "";
                      this.userData.country_calling_code = "";
                      this.userData.country_code = "";
                      this.isValid = false;
                      this.cellPhone = "";
                      this.userData.group = null;
                      this.userData.primary_station = "";
                      this.primanyStationId = "";
                      this.userData.orga_code = null;
                      this.userData.reports_to = null;
                      this.userData.secondary_station = [];
                      this.secondary_station = [];
                      this.delegateData.delegate_by = "";
                      this.delegateData.delegate_to = "";
                      this.userData.contract = null;
                      this.userData.username_type = true;
                      this.userDetails = {
                        group_name: "",
                        reports_to: "",
                      };
                      this.userFlag = "";
                      this.delegateData.from_date = "";
                      this.delegateData.to_date = "";
                      this.stateTo.disabledDates.to = new Date();
                      this.stateFrom.disabledDates.to = new Date();
                      this.stateTo.disabledDates.from = "";
                      this.stateFrom.disabledDates.from = "";
                      if (this.$refs.typeahead) {
                        this.$refs.typeahead.inputValue = "";
                      }
                      if (this.$refs.typeaheadStation) {
                        this.$refs.typeaheadStation.inputValue = "";
                      }
                      this.$nextTick(() => {
                        this.$refs.observer.reset();
                        this.$bvModal.hide("modal-edit-user");
                      });
                      this.handleClose();
                      this.manageUserList();
                    })
                    .catch((error) => {
                      if (error.response.status == 400) {
                        let errorResp = {
                          msg: error.response.data.message,
                          popup: true,
                        };
                        EventBus.$emit("error_resp", errorResp);
                        return;
                      }
                    });
                } else {
                  this.response.msg = response.data;
                  this.response.popup = true;
                  EventBus.$emit("success_resp", this.response);
                  this.userId = "";
                  this.userStatus = "";
                  this.userData.first_name = "";
                  this.userData.middle_name = "";
                  this.userData.last_name = "";
                  this.userData.username = "";
                  this.userData.proxy_email = "";
                  this.phoneVal = "";
                  this.userData.phone_no = "";
                  this.userData.country_calling_code = "";
                  this.userData.country_code = "";
                  this.isValid = false;
                  this.cellPhone = "";
                  this.userData.group = null;
                  this.userData.primary_station = "";
                  this.primanyStationId = "";
                  this.userData.orga_code = null;
                  this.userData.reports_to = null;
                  this.userData.secondary_station = [];
                  this.secondary_station = [];
                  this.userData.contract = null;
                  this.userData.username_type = true;
                  this.userDetails = {
                    group_name: "",
                    reports_to: "",
                  };
                  if (this.$refs.typeahead) {
                    this.$refs.typeahead.inputValue = "";
                  }
                  if (this.$refs.typeaheadStation) {
                    this.$refs.typeaheadStation.inputValue = "";
                  }
                  this.$nextTick(() => {
                    this.$refs.observer.reset();
                    this.$bvModal.hide("modal-edit-user");
                  });
                  this.handleClose();
                  this.manageUserList();
                }
              }
            })
            .catch((err) => {
              this.messsage_loader = false;
              if (err.response.status == 400) {
                this.response.msg = err.response.data.response;
                this.response.popup = true;
                EventBus.$emit("error_resp", this.response);
              }
            });
        } else {
          this.userData.primary_station = this.primanyStationId;
          HTTP_formdata.put("users/edit_users/" + this.userId, this.userData)
            .then((response) => {
              if (response.status == 200) {
                this.messsage_loader = false;
                if (this.delegateData.delegate_to != "") {
                  this.delegateData.delegate_by = this.userId;
                  HTTP_formdata.post(
                    "delegation/add_delegation",
                    this.delegateData
                  )
                    .then((resp) => {
                      this.response.msg = response.data;
                      this.response.popup = true;
                      EventBus.$emit("success_resp", this.response);
                      this.userStatus = "";
                      this.userId = "";
                      this.userData.first_name = "";
                      this.userData.middle_name = null;
                      this.userData.last_name = "";
                      this.userData.username = "";
                      this.userData.proxy_email = "";
                      this.phoneVal = "";
                      this.userData.phone_no = "";
                      this.userData.country_calling_code = "";
                      this.userData.country_code = "";
                      this.isValid = false;
                      this.cellPhone = "";
                      this.userData.group = null;
                      this.userData.primary_station = "";
                      this.primanyStationId = "";
                      this.userData.orga_code = null;
                      this.userData.reports_to = null;
                      this.userData.secondary_station = [];
                      this.secondary_station = [];
                      this.delegateData.delegate_by = "";
                      this.delegateData.delegate_to = "";
                      this.userData.contract = null;
                      this.userData.username_type = true;
                      this.userDetails = {
                        group_name: "",
                        reports_to: "",
                      };
                      this.userFlag = "";
                      this.delegateData.from_date = "";
                      this.delegateData.to_date = "";
                      this.stateTo.disabledDates.to = new Date();
                      this.stateFrom.disabledDates.to = new Date();
                      this.stateTo.disabledDates.from = "";
                      this.stateFrom.disabledDates.from = "";
                      if (this.$refs.typeahead) {
                        this.$refs.typeahead.inputValue = "";
                      }
                      if (this.$refs.typeaheadStation) {
                        this.$refs.typeaheadStation.inputValue = "";
                      }
                      this.$nextTick(() => {
                        this.$refs.observer.reset();
                        this.$bvModal.hide("modal-edit-user");
                      });
                      this.handleClose();
                      this.manageUserList();
                    })
                    .catch((error) => {
                      if (error.response.status == 400) {
                        let errorResp = {
                          msg: error.response.data.message,
                          popup: true,
                        };
                        EventBus.$emit("error_resp", errorResp);
                        return;
                      }
                    });
                } else {
                  this.response.msg = response.data;
                  this.response.popup = true;
                  EventBus.$emit("success_resp", this.response);
                  this.userId = "";
                  this.userStatus = "";
                  this.userData.first_name = "";
                  this.userData.middle_name = "";
                  this.userData.last_name = "";
                  this.userData.username = "";
                  this.userData.proxy_email = "";
                  this.phoneVal = "";
                  this.userData.phone_no = "";
                  this.userData.country_calling_code = "";
                  this.userData.country_code = "";
                  this.isValid = false;
                  this.cellPhone = "";
                  this.userData.group = null;
                  this.userData.primary_station = "";
                  this.primanyStationId = "";
                  this.userData.orga_code = null;
                  this.userData.reports_to = null;
                  this.userData.secondary_station = [];
                  this.secondary_station = [];
                  this.userData.contract = null;
                  this.userData.username_type = true;
                  this.userDetails = {
                    group_name: "",
                    reports_to: "",
                  };
                  if (this.$refs.typeahead) {
                    this.$refs.typeahead.inputValue = "";
                  }
                  if (this.$refs.typeaheadStation) {
                    this.$refs.typeaheadStation.inputValue = "";
                  }
                  this.$nextTick(() => {
                    this.$refs.observer.reset();
                    this.$bvModal.hide("modal-edit-user");
                  });
                  this.handleClose();
                  this.manageUserList();
                }
              }
            })
            .catch((err) => {
              this.messsage_loader = false;
              if (err.response.status == 400) {
                this.response.msg = err.response.data.response;
                this.response.popup = true;
                EventBus.$emit("error_resp", this.response);
              }
            });
        }
      }
    },
    reportsToChange() {
      this.reportsToResult = [{ value: null, text: "Select", disabled: true }];
      this.orgResult = [{ value: null, text: "Select", disabled: true }];
      this.userData.primary_station = "";
      this.primanyStationId = "";
      this.userData.orga_code = null;
      this.userData.reports_to = null;
      this.disableStation = false;
      if (this.$refs.typeaheadStation) {
        this.$refs.typeaheadStation.inputValue = "";
      }
      let clear = "clear";
      EventBus.$emit("clearDataBasedStation", clear);
      this.$nextTick(() => {
        this.$refs.observer.reset();
      });
      HTTP.get("groups/get_reports_to/" + this.userData.group)
        .then((response) => {
          if (response.status == 200) {
            this.reportsToResult = [{ value: null, text: "", disabled: true }];
            this.orgResult = [{ value: null, text: "Select", disabled: true }];
            response.data.reports_to.forEach((val) => {
              this.reportsToResult.push({
                value: val.group_public_id,
                text: val.group_name,
              });
            });
            // response.data.orga_code.forEach((val) => {
            //   this.orgResult.push({ value: val, text: val });
            // });
            this.reportsToResult
              .sort((a, b) => {
                const nameA = a.text.toUpperCase(); // ignore case
                const nameB = b.text.toUpperCase(); // ignore case
                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
                return 0; // names are equal
              })
              .map((group) => ({
                value: group.group_public_id,
                text: group.group_name,
              }));
          }
        })
        .catch((error) => {});
    },
    onClickGenrate() {
      var generatePassword = require("generate-password");
      this.password = "";
      this.password = generatePassword.generate({
        length: 10,
        numbers: true,
        symbols: true,
        exclude: "\"'",
        strict: true,
      });
    },
    updatePassword() {
      this.messsage_loader = true;
      let json = {
        password: this.password,
      };
      HTTP_formdata.put("users/store_random_password/" + this.userId, json)
        .then((response) => {
          if (response.status == 200) {
            this.enablePrint = true;
            this.messsage_loader = false;
            this.response.msg = response.data.response;
            this.response.popup = true;
            EventBus.$emit("success_resp", this.response);
            this.manageUserList();
          }
        })
        .catch((err) => {});
    },
    downloadPDF() {
      var canvasElement = document.createElement("canvas");
      html2canvas(this.$refs.content, {
        scale: 1,
        scrollX: 0,
        scrollY: 0,
      }).then(function (canvas) {
        var logo = new Image();
        var logoURL =
          "data:image/png;base64,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";
        var imgData = canvas.toDataURL("image/jpeg");
        var imgWidth = 380;
        var pageHeight = 537;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;

        var doc = new jsPDF("p", "px", "a4");
        var position = 0;
        doc.addImage(logoURL, "png", 145, 30, 150, 43);
        const tableTop = 43 + 30 + 10;
        doc.addImage(imgData, "JPEG", 30, tableTop, imgWidth, imgHeight);
        doc.save("User Details.pdf");
      });
    },
    getExcelSheet() {
      axios({
        url: BASE_URL_VER + "users/get_user_list",
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: "Bearer " + isloggedin.token,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          if (response.status == 200) {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", "Users.xlsx");
            document.body.appendChild(fileLink);
            fileLink.click();
          }
        })
        .catch((err) => {
          if (err.response.status == 400) {
            this.response.msg = err.response.data.message;
            this.response.popup = true;
            EventBus.$emit("error_resp", this.response);
          }
        });
    },
    deleteUser() {
      HTTP.delete("users/delete/" + this.userId)
        .then((response) => {
          this.messsage_loader = false;
          if (response.data.code == 200) {
            this.response.msg = response.data.response;
            this.response.popup = true;
            EventBus.$emit("success_resp", this.response);
            this.userStatus = "";
            this.userId = "";
            this.userData.proxy_email = "";
            this.userResult = [];
            this.manageUserList();
          }
        })
        .catch((err) => {
          this.messsage_loader = false;
          if (err.response.status == 400) {
            this.response.msg = err.response.data.response;
            this.response.popup = true;
            EventBus.$emit("error_resp", this.response);
            this.userStatus = "";
            this.userId = "";
            this.userData.proxy_email = "";
          }
        });
    },
    sendRemindersCheck() {
      this.networkConnect();
      if (this.onLine == true || this.onLine == null) {
        this.reminder_loader = true;
        this.reminderCheck = true;
        let filterData = this.paginate_params.filter
          ? "&filter=" + this.paginate_params.filter
          : "";
        HTTP.get(
          "users/get_inactive_users?status=" +
            this.paginate_params.status +
            filterData
        )
          .then((response) => {
            if (response.status == 200 && response.data.response.length > 0) {
              this.totalCount = response.data.totalLength;
              this.inactiveUserList = response.data.response;
              this.completedCount = 0;
              this.setAPITimer();
            } else {
              this.reminderCheck = false;
              this.response.msg = "Failed to send reminder";
              this.response.popup = true;
              EventBus.$emit("error_resp", this.response);
              this.totalCount = 0;
              this.inactiveUserList = [];
              this.completedCount = 0;
              this.emailCount = 0;
              this.proxyEmailCount = 0;
              this.nonEmailCount = 0;
              this.hundredCounter = 0;
            }
          })
          .catch((err) => {
            this.reminder_loader = false;
            if (err.response.status == 400) {
              this.reminderCheck = false;
              this.response.msg = "Failed to send reminder";
              this.response.popup = true;
              EventBus.$emit("error_resp", this.response);
              this.totalCount = 0;
              this.inactiveUserList = [];
              this.completedCount = 0;
              this.emailCount = 0;
              this.proxyEmailCount = 0;
              this.nonEmailCount = 0;
              this.hundredCounter = 0;
            }
          });
      }
    },
    setAPITimer() {
      this.timerCheck = true;
      this.timer = setInterval(() => {
        clearInterval(this.timer);
        this.timer = false;
        if (this.request) this.cancel();
        let waitTime = this.hundredCounter < 100 ? 15000 : 30000;
        this.hundredCounter = 0;
        setTimeout(() => {
          this.setAPITimer();
        }, waitTime);
      }, 60000);
      this.sendReminderInitial();
    },
    async sendReminderInitial(recall) {
      this.count_loader = true;
      let errorCheck = 0;
      if (this.onLine == true || this.onLine == null) {
        for (let i = this.completedCount; i < this.totalCount; i++) {
          if (this.onLine == true || this.onLine == null) {
            this.counterCheck = true;
            if (this.timer == false) {
              break;
            } else {
              if (this.hundredCounter >= 100) {
                break;
              } else {
                if (this.inactiveUserList[i].type == "non_email") {
                  this.nonEmailCount++;
                  this.completedCount++;
                } else {
                  this.axiosSource = axios.CancelToken.source();
                  this.request = { cancel: this.axiosSource.cancel };
                  await HTTP.get(
                    "users/send_pending_activation_reminders/" +
                      this.inactiveUserList[i].public_id,
                    { cancelToken: this.axiosSource.token }
                  )
                    .then((response) => {
                      if (response.status == 200) {
                        this.clearOldRequest();
                        if (this.inactiveUserList[i].type == "email") {
                          this.emailCount.success++;
                        } else if (
                          this.inactiveUserList[i].type == "proxy_email"
                        ) {
                          this.proxyEmailCount.success++;
                        }
                        this.completedCount++;
                        this.hundredCounter++;
                      }
                    })
                    .catch((err) => {
                      if (axios.isCancel(err)) {
                      } else {
                        this.clearOldRequest();
                        if (!err.response) {
                          errorCheck = 1;
                        } else if (err.response.status == 400) {
                          if (this.inactiveUserList[i].type == "email") {
                            this.emailCount.fail++;
                          } else if (
                            this.inactiveUserList[i].type == "proxy_email"
                          ) {
                            this.proxyEmailCount.fail++;
                          }
                          this.completedCount++;
                          this.hundredCounter++;
                        } else {
                          errorCheck = 1;
                        }
                      }
                    });
                  if (errorCheck == 1) {
                    errorCheck = 0;
                    break;
                  }
                }
              }
            }
          } else {
            break;
          }
        }
        setTimeout(() => {
          if (this.completedCount == this.totalCount) {
            clearInterval(this.timer);
            this.timer = false;
            let respDetail = [];

            if (this.emailCount.success > 0)
              respDetail.push({
                count: this.emailCount.success,
                msg:
                  this.emailCount.success == 1
                    ? "User with Registered e-mail ID"
                    : "Users with Registered e-mail ID",
                type: "success",
              });
            if (this.proxyEmailCount.success > 0)
              respDetail.push({
                count: this.proxyEmailCount.success,
                msg:
                  this.proxyEmailCount.success == 1
                    ? "User with Proxy e-mail ID"
                    : "Users with Proxy e-mail ID",
                type: "success",
              });
            if (this.emailCount.fail > 0 || this.proxyEmailCount.fail > 0)
              respDetail.push({
                count: this.emailCount.fail + this.proxyEmailCount.fail,
                msg:
                  this.emailCount.fail + this.proxyEmailCount.fail == 1
                    ? "User e-mail not sent"
                    : "Users e-mail not sent",
                type: "fail",
              });
            if (this.nonEmailCount > 0)
              respDetail.push({
                count: this.nonEmailCount,
                msg:
                  this.nonEmailCount == 1
                    ? "User with No e-mail ID"
                    : "Users with No e-mail ID",
                type: "fail",
              });

            this.reminder_loader = false;
            this.count_loader = false;

            let responseData = {
              popup: true,
              data: respDetail,
              title: "Reminders sent",
              loader: false,
            };
            EventBus.$emit("confirm_count_resp", responseData);

            setTimeout(() => {
              EventBus.$emit("confirmPopUPClose", true);
              this.reminderCheck = false;
              this.timerCheck = false;
              this.counterCheck = false;
              this.totalCount = 0;
              this.inactiveUserList = [];
              this.completedCount = 0;
              this.emailCount = { success: 0, fail: 0 };
              this.proxyEmailCount = { success: 0, fail: 0 };
              this.nonEmailCount = 0;
              this.hundredCounter = 0;
            }, 2000);
          }
        }, 2000);
      }
    },
    cancel() {
      this.request.cancel();
      this.clearOldRequest();
    },
    clearOldRequest() {
      this.request = null;
    },
    networkConnect(val) {
      let network = val ? val : this.onLine;
      if (network != null) {
        if (network == false) {
          this.$bvModal.show("modal-no-internet");
          this.counterAPICheck = this.reminderCheck == true ? true : false;
          if (this.request) this.cancel();
        } else if (network == true) {
          this.$bvModal.hide("modal-no-internet");
          if (this.counterAPICheck == true) {
            if (this.reminderCheck == true) {
              if (this.timerCheck == true) {
                if (this.counterCheck == true) this.sendReminderInitial();
                else {
                  if (this.timer == false) this.setAPITimer();
                  else this.sendReminderInitial();
                }
              } else this.sendRemindersCheck();
            }
            this.counterAPICheck = false;
          }
        }
      }
    },
    addVendor() {
      let jsonData = {
        name: this.vendorName,
      };
      HTTP_formdata.post("vendors/add", jsonData)
        .then((response) => {
          EventBus.$emit("vendorData", this.vendorName);
          this.$bvModal.hide("add-vendor");
          this.userData.vendor = response.data.public_id;
          this.response.msg = response.data.message;
          this.response.popup = true;
          EventBus.$emit("success_resp", this.response);
        })
        .catch((err) => {
          if (err.response.status == 400) {
            this.response.msg = err.response.data.message;
            this.response.popup = true;
            EventBus.$emit("error_resp", this.response);
          }
        });
    },
    showVendorPopUp() {
      this.vendorName = "";
      this.listVendor();
    },
    listVendor() {
      HTTP.get(
        "vendors/list?limit=" +
          this.vendorPaginate.limit +
          "&page=" +
          this.vendorPaginate.page
      )
        .then((response) => {
          if (response.status == 200) {
            this.vendorPaginate.rows = response.data.total_count;
            this.vendorData = response.data.vendors;
          }
        })
        .catch((error) => {
          if (this.$refs.typeaheadVendor)
            this.$refs.typeaheadVendor.inputValue = "";
          this.vendorData = [];
          this.vendorPaginate.rows = 10;
        });
    },
    confirm_popup(data) {
      this.vendorDetail.flag = true;
      this.vendorDetail.data = data;
      EventBus.$emit("deleteSelected", data.name);
    },
    deleteVendor() {
      HTTP.delete("vendors/delete/" + this.vendorDetail.data.public_id)
        .then((response) => {
          this.messsage_loader = false;
          if (response.data.code == 200) {
            this.response.msg = response.data.message;
            this.response.popup = true;
            EventBus.$emit("success_resp", this.response);
            if (this.userData.vendor == this.vendorDetail.data.public_id) {
              EventBus.$emit("clearVendorData");
              this.userData.vendor = "";
            }
            this.vendorDetail = { flag: false, data: "" };
            this.listVendor();
          }
        })
        .catch((err) => {
          this.messsage_loader = false;
          if (err.response.status == 400) {
            this.response.msg = err.response.data.message;
            this.response.popup = true;
            EventBus.$emit("error_resp", this.response);
            this.vendorDetail = { flag: false, data: "" };
          }
        });
    },
  },
};
</script>
<style scoped>
@import "./def_function.css";
@import "./manage_users.css";
tr.inactive td {
  color: #cccccc;
}
tr.inactive .btn-inactive {
  opacity: 0.15;
  cursor: default;
}
#stationcode {
  display: none;
}
.checkUser-station-authority {
  display: flex;
  white-space: nowrap;
}
.checkUser-station-authority span {
  white-space: normal;
  margin-left: 5px;
}
.wait-text,
.loading-text {
  color: #003261;
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.05em;
  z-index: 1;
}
.wait-text {
  margin-bottom: -10px;
}
.loading-text {
  margin-top: -10px;
}
.spinner-div.load-outer {
  flex-direction: column;
}
</style>
